import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {permScope} from "@/helper/constant";
import {useAuthInfo} from "@/store/account.c";
import {useQueryUserPage, UserPageVO} from "@/service/user.s";
import {ViewUser} from "@/pages/User/ViewUser";
import Chip from "@mui/material/Chip";
import {AuthButtonVO} from "@/service/menu.s";
import {WriteUser} from "@/pages/User/WriteUser";

export const UserListPage = () => {
    const {
        mutate: userPageMutate,
        data: userPageData,
        isPending: userPagePending,
    } = useQueryUserPage()
    const {role: {dataScope}} = useAuthInfo()

    const columns: GridColDef<UserPageVO>[] = [
        {
            field: "username",
            headerName: "姓名",
            flex: 0.28
        },
        {
            field: "account",
            headerName: "账号",
            flex: 0.3
        },
        {
            field: "mobile",
            headerName: "联系电话",
            headerAlign: "center",
            align: "center",
            flex: 0.3
        },
        {
            field: "role",
            headerName: "角色",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            renderCell: ({row}) => <Chip variant={'outlined'} color={'info'} label={row?.role?.roleName}/>
        },
        {
            field: "dept",
            headerName: "部门",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            renderCell: ({row}) => <Chip variant={'outlined'} color={'success'} label={row?.dept?.deptName}/>
        },
        {
            field: "gender",
            headerName: "性别",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            valueFormatter: value => value == 1 && "男" || value == 2 && "女" || "未知"
        },
        {
            field: "status", headerName: "状态", flex: 0.15,
            renderCell: ({row}) => <Chip variant={'outlined'} size={'small'} color={'warning'} label={row.status}/>
        },
        {
            field: "entryTime",
            headerName: "入职时间",
            headerAlign: "center",
            flex: 0.3,
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    const btnCallback = async ({btn, keys, onSearch}: BtnType<UserPageVO>) => {
    }

    return (
        <ProTable<UserPageVO>
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            loading={userPagePending}
            btnCallback={btnCallback}
            renderDrawer={{view: <ViewUser/>, write: <WriteUser/>}}
            columns={columns}
            data={userPageData?.data}
            onSearch={(params) => {
                userPageMutate({...params});
            }}
            verifyBtns={(row: UserPageVO, btns: AuthButtonVO[]) => {
                return btns.map((btn) => {
                        if (btn.alias == 'audit') {
                            return {...btn, disabled: row.statusId == 2, maxWidth: 'xs', body: <></>}
                        }
                        return btn
                    }
                )
            }
            }
            code={"user"}
        />
    );
};
